export const moves = {
  1: "Klaps",
  2: "Karateschlag",
  3: "Duplexhieb",
  4: "Kometenhieb",
  5: "Megahieb",
  6: "Zahltag",
  7: "Feuerschlag",
  8: "Eishieb",
  9: "Donnerschlag",
  10: "Kratzer",
  11: "Klammer",
  12: "Guillotine",
  13: "Klingensturm",
  14: "Schwerttanz",
  15: "Zerschneider",
  16: "Windstoß",
  17: "Flügelschlag",
  18: "Wirbelwind",
  19: "Fliegen",
  20: "Klammergriff",
  21: "Slam",
  22: "Rankenhieb",
  23: "Stampfer",
  24: "Doppelkick",
  25: "Megakick",
  26: "Sprungkick",
  27: "Fegekick",
  28: "Sandwirbel",
  29: "Kopfnuss",
  30: "Hornattacke",
  31: "Furienschlag",
  32: "Hornbohrer",
  33: "Tackle",
  34: "Bodyslam",
  35: "Wickel",
  36: "Bodycheck",
  37: "Fuchtler",
  38: "Risikotackle",
  39: "Rutenschlag",
  40: "Giftstachel",
  41: "Duonadel",
  42: "Nadelrakete",
  43: "Silberblick",
  44: "Biss",
  45: "Heuler",
  46: "Brüller",
  47: "Gesang",
  48: "Superschall",
  49: "Ultraschall",
  50: "Aussetzer",
  51: "Säure",
  52: "Glut",
  53: "Flammenwurf",
  54: "Weißnebel",
  55: "Aquaknarre",
  56: "Hydropumpe",
  57: "Surfer",
  58: "Eisstrahl",
  59: "Blizzard",
  60: "Psystrahl",
  61: "Blubbstrahl",
  62: "Aurorastrahl",
  63: "Hyperstrahl",
  64: "Pikser",
  65: "Bohrschnabel",
  66: "Überroller",
  67: "Fußkick",
  68: "Konter",
  69: "Geowurf",
  70: "Stärke",
  71: "Absorber",
  72: "Megasauger",
  73: "Egelsamen",
  74: "Wachstum",
  75: "Rasierblatt",
  76: "Solarstrahl",
  77: "Giftpuder",
  78: "Stachelspore",
  79: "Schlafpuder",
  80: "Blättertanz",
  81: "Fadenschuss",
  82: "Drachenwut",
  83: "Feuerwirbel",
  84: "Donnerschock",
  85: "Donnerblitz",
  86: "Donnerwelle",
  87: "Donner",
  88: "Steinwurf",
  89: "Erdbeben",
  90: "Geofissur",
  91: "Schaufler",
  92: "Toxin",
  93: "Konfusion",
  94: "Psychokinese",
  95: "Hypnose",
  96: "Meditation",
  97: "Agilität",
  98: "Ruckzuckhieb",
  99: "Raserei",
  100: "Teleport",
  101: "Nachtnebel",
  102: "Mimikry",
  103: "Kreideschrei",
  104: "Doppelteam",
  105: "Genesung",
  106: "Härtner",
  107: "Komprimator",
  108: "Rauchwolke",
  109: "Konfusstrahl",
  110: "Panzerschutz",
  111: "Einigler",
  112: "Barriere",
  113: "Lichtschild",
  114: "Dunkelnebel",
  115: "Reflektor",
  116: "Energiefokus",
  117: "Geduld",
  118: "Metronom",
  119: "Spiegeltrick",
  120: "Finale",
  121: "Eierbombe",
  122: "Schlecker",
  123: "Smog",
  124: "Schlammbad",
  125: "Knochenkeule",
  126: "Feuersturm",
  127: "Kaskade",
  128: "Schnapper",
  129: "Sternschauer",
  130: "Schädelwumme",
  131: "Dornkanone",
  132: "Umklammerung",
  133: "Amnesie",
  134: "Psykraft",
  135: "Weichei",
  136: "Turmkick",
  137: "Schlangenblick",
  138: "Traumfresser",
  139: "Giftwolke",
  140: "Stakkato",
  141: "Blutsauger",
  142: "Todeskuss",
  143: "Himmelsfeger",
  144: "Wandler",
  145: "Blubber",
  146: "Irrschlag",
  147: "Pilzspore",
  148: "Blitz",
  149: "Psywelle",
  150: "Platscher",
  151: "Säurepanzer",
  152: "Krabbhammer",
  153: "Explosion",
  154: "Kratzfurie",
  155: "Knochmerang",
  156: "Erholung",
  157: "Steinhagel",
  158: "Hyperzahn",
  159: "Schärfer",
  160: "Umwandlung",
  161: "Triplette",
  162: "Superzahn",
  163: "Schlitzer",
  164: "Delegator",
  165: "Verzweifler",
  166: "Nachahmer",
  167: "Dreifachkick",
  168: "Raub",
  169: "Spinnennetz",
  170: "Willensleser",
  171: "Nachtmahr",
  172: "Flammenrad",
  173: "Schnarcher",
  174: "Fluch",
  175: "Dreschflegel",
  176: "Umwandlung2",
  177: "Luftstoß",
  178: "Baumwollsaat",
  179: "Gegenschlag",
  180: "Groll",
  181: "Pulverschnee",
  182: "Schutzschild",
  183: "Tempohieb",
  184: "Grimasse",
  185: "Finte",
  186: "Bitterkuss",
  187: "Bauchtrommel",
  188: "Matschbombe",
  189: "Lehmschelle",
  190: "Octazooka",
  191: "Stachler",
  192: "Blitzkanone",
  193: "Scharfblick",
  194: "Abgangsbund",
  195: "Abgesang",
  196: "Eissturm",
  197: "Scanner",
  198: "Knochenhatz",
  199: "Zielschuss",
  200: "Wutanfall",
  201: "Sandsturm",
  202: "Gigasauger",
  203: "Ausdauer",
  204: "Charme",
  205: "Walzer",
  206: "Trugschlag",
  207: "Angeberei",
  208: "Milchgetränk",
  209: "Funkensprung",
  210: "Zornklinge",
  211: "Stahlflügel",
  212: "Horrorblick",
  213: "Anziehung",
  214: "Schlafrede",
  215: "Vitalglocke",
  216: "Rückkehr",
  217: "Geschenk",
  218: "Frustration",
  219: "Bodyguard",
  220: "Leidteiler",
  221: "Läuterfeuer",
  222: "Intensität",
  223: "Wuchtschlag",
  224: "Vielender",
  225: "Feuerodem",
  226: "Stafette",
  227: "Zugabe",
  228: "Verfolgung",
  229: "Turbodreher",
  230: "Lockduft",
  231: "Eisenschweif",
  232: "Metallklaue",
  233: "Überwurf",
  234: "Morgengrauen",
  235: "Synthese",
  236: "Mondschein",
  237: "Kraftreserve",
  238: "Kreuzhieb",
  239: "Windhose",
  240: "Regentanz",
  241: "Sonnentag",
  242: "Knirscher",
  243: "Spiegelcape",
  244: "Psycho-Plus",
  245: "Turbotempo",
  246: "Antik-Kraft",
  247: "Spukball",
  248: "Seher",
  249: "Zertrümmerer",
  250: "Whirlpool",
  251: "Prügler",
  252: "Mogelhieb",
  253: "Aufruhr",
  254: "Horter",
  255: "Entfessler",
  256: "Verzehrer",
  257: "Hitzewelle",
  258: "Hagelsturm",
  259: "Folterknecht",
  260: "Schmeichler",
  261: "Irrlicht",
  262: "Memento-Mori",
  263: "Fassade",
  264: "Power-Punch",
  265: "Riechsalz",
  266: "Spotlight",
  267: "Natur-Kraft",
  268: "Ladevorgang",
  269: "Verhöhner",
  270: "Rechte Hand",
  271: "Trickbetrug",
  272: "Rollenspiel",
  273: "Wunschtraum",
  274: "Zuschuss",
  275: "Verwurzler",
  276: "Kraftkoloss",
  277: "Magiemantel",
  278: "Aufbereitung",
  279: "Vergeltung",
  280: "Durchbruch",
  281: "Gähner",
  282: "Abschlag",
  283: "Notsituation",
  284: "Eruption",
  285: "Fähigkeitstausch",
  286: "Begrenzer",
  287: "Heilung",
  288: "Nachspiel",
  289: "Übernahme",
  290: "Geheimpower",
  291: "Taucher",
  292: "Armstoß",
  293: "Tarnung",
  294: "Schweifglanz",
  295: "Scheinwerfer",
  296: "Nebelball",
  297: "Daunenreigen",
  298: "Taumeltanz",
  299: "Feuerfeger",
  300: "Lehmsuhler",
  301: "Frostbeule",
  302: "Nietenranke",
  303: "Tagedieb",
  304: "Schallwelle",
  305: "Giftzahn",
  306: "Zermalmklaue",
  307: "Lohekanonade",
  308: "Aquahaubitze",
  309: "Sternenhieb",
  310: "Erstauner",
  311: "Meteorologe",
  312: "Aromakur",
  313: "Trugträne",
  314: "Windschnitt",
  315: "Hitzekoller",
  316: "Schnüffler",
  317: "Felsgrab",
  318: "Silberhauch",
  319: "Metallsound",
  320: "Grasflöte",
  321: "Spaßkanone",
  322: "Kosmik-Kraft",
  323: "Fontränen",
  324: "Ampelleuchte",
  325: "Finsterfaust",
  326: "Sondersensor",
  327: "Himmelhieb",
  328: "Sandgrab",
  329: "Eiseskälte",
  330: "Lehmbrühe",
  331: "Kugelsaat",
  332: "Aero-Ass",
  333: "Eisspeer",
  334: "Eisenabwehr",
  335: "Rückentzug",
  336: "Jauler",
  337: "Drachenklaue",
  338: "Flora-Statue",
  339: "Protzer",
  340: "Sprungfeder",
  341: "Lehmschuss",
  342: "Giftschweif",
  343: "Bezirzer",
  344: "Volttackle",
  345: "Zauberblatt",
  346: "Nassmacher",
  347: "Gedankengut",
  348: "Laubklinge",
  349: "Drachentanz",
  350: "Felswurf",
  351: "Schockwelle",
  352: "Aquawelle",
  353: "Kismetwunsch",
  354: "Psyschub",
  355: "Ruheort",
  356: "Erdanziehung",
  357: "Wunderauge",
  358: "Weckruf",
  359: "Hammerarm",
  360: "Gyroball",
  361: "Heilopfer",
  362: "Lake",
  363: "Beerenkräfte",
  364: "Offenlegung",
  365: "Pflücker",
  366: "Rückenwind",
  367: "Akupressur",
  368: "Metallstoß",
  369: "Kehrtwende",
  370: "Nahkampf",
  371: "Gegenstoß",
  372: "Gewissheit",
  373: "Itemsperre",
  374: "Schleuder",
  375: "Psybann",
  376: "Trumpfkarte",
  377: "Heilblockade",
  378: "Auswringen",
  379: "Krafttrick",
  380: "Magensäfte",
  381: "Beschwörung",
  382: "Egotrip",
  383: "Imitator",
  384: "Krafttausch",
  385: "Schutztausch",
  386: "Strafattacke",
  387: "Zuflucht",
  388: "Sorgensamen",
  389: "Tiefschlag",
  390: "Giftspitzen",
  391: "Statustausch",
  392: "Wasserring",
  393: "Magnetflug",
  394: "Flammenblitz",
  395: "Kraftwelle",
  396: "Aurasphäre",
  397: "Steinpolitur",
  398: "Gifthieb",
  399: "Finsteraura",
  400: "Nachthieb",
  401: "Nassschweif",
  402: "Samenbomben",
  403: "Luftschnitt",
  404: "Kreuzschere",
  405: "Käfergebrumm",
  406: "Drachenpuls",
  407: "Drachenstoß",
  408: "Juwelenkraft",
  409: "Ableithieb",
  410: "Vakuumwelle",
  411: "Fokusstoß",
  412: "Energieball",
  413: "Sturzflug",
  414: "Erdkräfte",
  415: "Wechseldich",
  416: "Gigastoß",
  417: "Ränkeschmied",
  418: "Patronenhieb",
  419: "Lawine",
  420: "Eissplitter",
  421: "Dunkelklaue",
  422: "Donnerzahn",
  423: "Eiszahn",
  424: "Feuerzahn",
  425: "Schattenstoß",
  426: "Schlammbombe",
  427: "Psychoklinge",
  428: "Zen-Kopfstoß",
  429: "Spiegelsalve",
  430: "Lichtkanone",
  431: "Kraxler",
  432: "Auflockern",
  433: "Bizarroraum",
  434: "Draco Meteor",
  435: "Ladungsstoß",
  436: "Flammensturm",
  437: "Blättersturm",
  438: "Blattgeißel",
  439: "Felswerfer",
  440: "Giftstreich",
  441: "Mülltreffer",
  442: "Eisenschädel",
  443: "Magnetbombe",
  444: "Steinkante",
  445: "Liebreiz",
  446: "Tarnsteine",
  447: "Strauchler",
  448: "Geschwätz",
  449: "Urteilskraft",
  450: "Käferbiss",
  451: "Ladestrahl",
  452: "Holzhammer",
  453: "Wasserdüse",
  454: "Schlagbefehl",
  455: "Blockbefehl",
  456: "Heilbefehl",
  457: "Kopfstoß",
  458: "Doppelschlag",
  459: "Zeitenlärm",
  460: "Raumschlag",
  461: "Lunartanz",
  462: "Quetschgriff",
  463: "Lavasturm",
  464: "Schlummerort",
  465: "Schocksamen",
  466: "Unheilböen",
  467: "Schemenkraft",
  468: "Klauenwetzer",
  469: "Rundumschutz",
  470: "Schutzteiler",
  471: "Kraftteiler",
  472: "Wunderraum",
  473: "Psychoschock",
  474: "Giftschock",
  475: "Autotomie",
  476: "Wutpulver",
  477: "Telekinese",
  478: "Magieraum",
  479: "Katapult",
  480: "Bergsturm",
  481: "Funkenflug",
  482: "Schlammwoge",
  483: "Falterreigen",
  484: "Rammboss",
  485: "Synchrolärm",
  486: "Elektroball",
  487: "Überflutung",
  488: "Nitroladung",
  489: "Einrollen",
  490: "Fußtritt",
  491: "Säurespeier",
  492: "Schmarotzer",
  493: "Wankelstrahl",
  494: "Zwango",
  495: "Galanterie",
  496: "Kanon",
  497: "Widerhall",
  498: "Zermürben",
  499: "Klärsmog",
  500: "Kraftvorrat",
  501: "Rapidschutz",
  502: "Seitentausch",
  503: "Siedewasser",
  504: "Hausbruch",
  505: "Heilwoge",
  506: "Bürde",
  507: "Freier Fall",
  508: "Gangwechsel",
  509: "Überkopfwurf",
  510: "Einäschern",
  511: "Verzögerung",
  512: "Akrobatik",
  513: "Typenspiegel",
  514: "Heimzahlung",
  515: "Wagemut",
  516: "Offerte",
  517: "Inferno",
  518: "Wassersäulen",
  519: "Feuersäulen",
  520: "Pflanzensäulen",
  521: "Voltwechsel",
  522: "Käfertrutz",
  523: "Dampfwalze",
  524: "Eisesodem",
  525: "Drachenrute",
  526: "Kraftschub",
  527: "Elektronetz",
  528: "Stromstoß",
  529: "Schlagbohrer",
  530: "Doppelhieb",
  531: "Herzstempel",
  532: "Holzgeweih",
  533: "Sanctoklinge",
  534: "Kalkklinge",
  535: "Brandstempel",
  536: "Grasmixer",
  537: "Quetschwalze",
  538: "Watteschild",
  539: "Nachtflut",
  540: "Psychostoß",
  541: "Kehrschelle",
  542: "Orkan",
  543: "Steinschädel",
  544: "Klikkdiskus",
  545: "Flammenball",
  546: "Techblaster",
  547: "Urgesang",
  548: "Mystoschwert",
  549: "Eiszeit",
  550: "Blitzschlag",
  551: "Blauflammen",
  552: "Feuerreigen",
  553: "Frostvolt",
  554: "Frosthauch",
  555: "Standpauke",
  556: "Eiszapfhagel",
  557: "V-Generator",
  558: "Kreuzflamme",
  559: "Kreuzdonner",
  560: "Flying Press",
  561: "Tatami-Schild",
  562: "Rülpser",
  563: "Pflüger",
  564: "Klebenetz",
  565: "Stachelfinale",
  566: "Phantomkraft",
  567: "Halloween",
  568: "Kampfgebrüll",
  569: "Plasmaschauer",
  570: "Parabolladung",
  571: "Waldesfluch",
  572: "Blütenwirbel",
  573: "Gefriertrockner",
  574: "Säuselstimme",
  575: "Abgangstirade",
  576: "Invertigo",
  577: "Diebeskuss",
  578: "Trickschutz",
  579: "Floraschutz",
  580: "Grasfeld",
  581: "Nebelfeld",
  582: "Elektrifizierung",
  583: "Knuddler",
  584: "Feenbrise",
  585: "Mondgewalt",
  586: "Überschallknall",
  587: "Feenschloss",
  588: "Königsschild",
  589: "Kameradschaft",
  590: "Vertrauenssache",
  591: "Diamantsturm",
  592: "Dampfschwall",
  593: "Dimensionsloch",
  594: "Wasser-Shuriken",
  595: "Magieflamme",
  596: "Schutzstacheln",
  597: "Duftwolke",
  598: "Mystowellen",
  599: "Giftfalle",
  600: "Pulverschleuder",
  601: "Geokontrolle",
  602: "Magnetregler",
  603: "Goldene Zeiten",
  604: "Elektrofeld",
  605: "Zauberschein",
  606: "Ehrentag",
  607: "Händchenhalten",
  608: "Kulleraugen",
  609: "Wangenrubbler",
  610: "Zurückhaltung",
  611: "Plage",
  612: "Steigerungshieb",
  613: "Unheilsschwingen",
  614: "Tausend Pfeile",
  615: "Tausend Wellen",
  616: "Bodengewalt",
  617: "Lux Calamitatis",
  618: "Ursprungswoge",
  619: "Abgrundsklinge",
  620: "Zenitstürmer",
  621: "Dimensionswahn",
};
